module.exports = __webpack_public_path__ + "static/media/porous.46048c24.png";